import { formatDistanceToNow } from 'date-fns'
import { ptBR, enUS, fr, es, hy } from 'date-fns/locale'
import i18n, { intlLocale } from './index'

const DATE_FNS_LOCALES = { 'pt-BR': ptBR, en: enUS, fr, es, hy }

export function fmtNum(n, opts = {}) {
  if (n == null || isNaN(n)) return '—'
  return new Intl.NumberFormat(intlLocale(), { maximumFractionDigits: 1, ...opts }).format(n)
}

export function fmtInt(n) {
  return fmtNum(n, { maximumFractionDigits: 0 })
}

export function fmtPct(frac, digits = 0) {
  if (frac == null || isNaN(frac)) return '—'
  return new Intl.NumberFormat(intlLocale(), {
    style: 'percent', maximumFractionDigits: digits,
  }).format(frac)
}

// Duração curta com as unidades do idioma ativo (o armênio não usa h/min/s latinos).
// Um só formatador para as telas: antes cada uma tinha o seu, com letras fixas.
export function fmtDurShort(secs) {
  if (secs == null || isNaN(secs)) return '—'
  const s = Math.max(0, Math.round(Number(secs)))
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60
  const u = (k) => i18n.t(`common:units.${k}`)
  if (h > 0) return `${h}${u('hours')} ${String(m).padStart(2, '0')}${u('minutes')}`
  if (m > 0) return `${m}${u('minutes')} ${String(sec).padStart(2, '0')}${u('seconds')}`
  return `${sec}${u('seconds')}`
}

// Dia/mês curto no formato do idioma (03/12 é 3 de dezembro em pt-BR e 12 de março em en).
export function fmtDayShort(d) {
  if (!d) return ''
  const date = d instanceof Date ? d : new Date(String(d).length <= 10 ? `${d}T12:00:00` : d)
  if (isNaN(date.getTime())) return String(d)
  return new Intl.DateTimeFormat(intlLocale(), { day: '2-digit', month: '2-digit' }).format(date)
}

// Hora do relógio no formato do idioma (24h em pt-BR/fr, 12h em en-US).
export function fmtClock(d, withSeconds = false) {
  if (!d) return '—'
  const date = d instanceof Date ? d : new Date(d)
  if (isNaN(date.getTime())) return '—'
  return new Intl.DateTimeFormat(intlLocale(), {
    hour: '2-digit', minute: '2-digit', ...(withSeconds ? { second: '2-digit' } : {}),
  }).format(date)
}

export function fmtDate(d, opts = { day: '2-digit', month: '2-digit', year: 'numeric' }) {
  if (!d) return '—'
  // Mesma guarda das irmãs desta função: Intl.format(new Date('lixo')) levanta
  // RangeError, e como não existe ErrorBoundary em lado nenhum, um instante
  // malformado vindo de um device apagava a tela inteira em vez de um campo.
  const date = d instanceof Date ? d : new Date(d)
  if (isNaN(date.getTime())) return '—'
  return new Intl.DateTimeFormat(intlLocale(), opts).format(date)
}

export function fmtDateTime(d) {
  return fmtDate(d, { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
}

export function fmtRelative(d, opts = {}) {
  // Guarda contra data inválida: este helper é usado em dezenas de telas e um único
  // valor malformado vindo da API estourava um RangeError que apagava a tela toda.
  const dt = new Date(d)
  if (!d || isNaN(dt.getTime())) return '—'
  return formatDistanceToNow(dt, {
    addSuffix: true,
    locale: DATE_FNS_LOCALES[i18n.language] || ptBR,
    ...opts,
  })
}
